export const GETTING_MARKETING_MATERIALS = 'GETTING_MARKETING_MATERIALS';
export const GOT_MARKETING_MATERIALS = 'GOT_MARKETING_MATERIALS';
export const UPDATE_MM_PROP = 'UPDATE_MM_PROP';
export const UPDATE_MM_PARTNER_PROP = 'UPDATE_MM_PARTNER_PROP';
export const EDIT_MM_STARTING = 'EDIT_MM_STARTING';
export const EDIT_MM_FINISHED = 'EDIT_MM_FINISHED';
export const CHECK_CONNECTION = 'CHECK_CONNECTION';
export const UNCHECK_CONNECTION = 'UNCHECK_CONNECTION';
export const SENDING_MARKETING_MATERIALS = 'SENDING_MARKETING_MATERIALS';
export const SENT_MARKETING_MATERIALS = 'SENT_MARKETING_MATERIALS';
export const GETTING_PARTNERS = '[share-MM]GETTING_PARTNERS';
export const GOT_PARTNERS = '[share-MM]GOT_PARTNERS';
export const UPDATE_PROP_MM_SIGNUP = 'UPDATE_PROP_MM_SIGNUP';
export const UPDATE_MM_SIGN_UP_PROP = 'UPDATE_MM_SIGN_UP_PROP';
export const UPDATE_MM_SIGN_UP_COMPANY = 'UPDATE_MM_SIGN_UP_COMPANY';
export const MM_SIGNUP_FAILED = 'MM_SIGNUP_FAILED';
export const MM_SIGNUP_SUCCESS = 'MM_SIGNUP_SUCCESS';
export const UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM = 'UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM';
export const MM_SIGN_UP_IN_PROCESS = 'MM_SIGN_UP_IN_PROCESS';
export const CLEAR_STORE = 'CLEAR_STORE';



// WEBPACK FOOTER //
// ./src/app/stores/marketing-materials/constants.js